/** @jsxImportSource @emotion/react */
import { mainContainer, mapContainer, mapWrapper } from './styles/PointData.styles';
import CustomMap from 'components/lab/lab_1/point_data/CustomMap';
import Sidebar from './components/Sidebar';
import { usePointData } from './hooks/usePointData';
import { useEffect } from 'react';
import { dataList } from 'components/lab/lab_1/point_data/dataList';

const PointData = () => {
    const {
        // 상태
        selectedCategory,
        featureCollection,
        mode,
        selectedRadioOption,
        pointVectorLayerVisible,
        selectedData,
        selectedSubArray,
        mapData,
        imageLayerVisible,
        imageLayerOpacity,
        status,

        // 상태 설정 함수
        setSelectedCategory,
        setMode,
        setSelectedRadioOption,
        setPointVectorLayerVisible,
        setSelectedData,
        setMapData,

        // 이벤트 핸들러
        handleCheckboxChange,
        handleRadioChange,
        onChangeVisibleHandle,
        onChangeOpacityHandle,
    } = usePointData();

    useEffect(() => {
        dataList.forEach((data) => data.id === 4 ? setSelectedData(data) : "");
    }, [])

    return (
        <div css={mainContainer}>
            {/* 사이드바 */}
            <Sidebar
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                imageLayerVisible={imageLayerVisible}
                onChangeVisibleHandle={onChangeVisibleHandle}
                imageLayerOpacity={imageLayerOpacity}
                onChangeOpacityHandle={onChangeOpacityHandle}
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                selectedSubArray={selectedSubArray}
                handleCheckboxChange={handleCheckboxChange}
                handleRadioChange={handleRadioChange}
                mode={mode}
                setMode={setMode}
                selectedRadioOption={selectedRadioOption}
                setSelectedRadioOption={setSelectedRadioOption}
                pointVectorLayerVisible={pointVectorLayerVisible}
                setPointVectorLayerVisible={setPointVectorLayerVisible}
                mapData={mapData}
                status={status}
            />

            {/* 지도 컨테이너 */}
            <div css={mapContainer}>
                <CustomMap
                    mode={mode}
                    featureCollection={featureCollection}
                    selectedCategory={selectedCategory}
                    selectedRadioOption={selectedRadioOption}
                    pointVectorLayerVisible={pointVectorLayerVisible}
                    mapData={mapData}
                    setMapData={setMapData}
                    imageLayerVisible={imageLayerVisible}
                    imageLayerOpacity={imageLayerOpacity}
                    selectedSubArray={selectedSubArray}
                    selectedData={selectedData}
                />
            </div>
        </div>
    );
};

export default PointData;
